export default [{
    id: 'FEATURES',
    name: 'Fonctionnalités',
    description: 'Ces cookies vous permettent d\'accéder à des fonctionnalités présentes sur Yurplan et gérées par des sites internet extérieurs à Yurplan',
    cookies: [{
        id: 'FACEBOOK_CONNEXION',
        title: 'Facebook',
        group: 'FEATURES',
        description: 'Ce cookie tiers déposé par Facebook vous permet de vous connecter à Yurplan depuis votre compte Facebook. Cette connexion vous permet de ne pas créer de compte directement sur notre site, mais aussi d\'y importer vos événements facebook.',
        link: 'https://www.facebook.com/policies/cookies/',
        cookiesNames: [
            'fbm_id',
            'fbsr_id',
            'spin',
            'act',
            'fr',
            'locale',
            'presence',
            'pl',
            'xs',
            'wd',
            'c_user',
            'sb',
            'datr',
        ],
    }, {
        id: 'TRUSTPILOT',
        title: 'TrustPilot',
        group: 'FEATURES',
        description: 'Ce cookie tiers déposé par TrustPilot nous permet d\'afficher notre score sur TrustPilot et vous permet d\'accéder aux commentaires des autres utilisateurs de la plateforme.',
        link: 'https://fr.legal.trustpilot.com/end-user-privacy-terms#cookies',
        cookiesNames: [
            'TP.uuid',
            '__RequestVerificationToken',
            '__asc',
            '__auc',
            'ajs_anonymous_id',
            'ajs_group_id',
            'ajs_user_id',
            'amplitude_id',
            'amplitude_idundefinedtrustpilot.com',
            'csrf-canary',
        ],
    }],
}, {
    id: 'ANALYTICS',
    name: 'Statistiques',
    description: 'Ces cookies nous aident par la collecte et la communication d\'informations à comprendre comment les visiteurs interagissent avec notre site.',
    cookies: [{
        id: 'GOOGLE_ANALYTICS',
        title: 'Google Analytics',
        group: 'ANALYTICS',
        description: 'Ce cookie tiers déposé par Google nous permet de mieux comprendre comment la Plateforme Yurplan est utilisée. Il permet de distinguer chaque utilisateur par l\'attribution d\'un identifiant unique.',
        link: 'https://policies.google.com/privacy?hl=fr&gl=fr',
        link2: 'https://policies.google.com/technologies/types?hl=fr',
        cookiesNames: [
            '_ga',
            '_gid',
            '_gat',
            'AMP_TOKEN',
            '__utma',
            '__utmt',
            '__utmb',
            '__utmc',
            '__utmz',
            '__utmv',
            '__utmx',
            '__utmxx',
            '_gaexp',
            // '_ga_<container-id>',
            // '_gac_gb_<container-id>',
            // '_gac_<property-id>',
        ],
        gtmKeys: ['ua', 'gaawc', 'gaawe', 'ga'],
    }, {
        id: 'MATOMO_EXEMPTED_CONSENT',
        title: 'Matomo exempté de consentement',
        group: 'ANALYTICS',
        description: 'Matomo en mode exempté de consentement permet à Yurplan de comprendre comment la plateforme Yurplan est utilisée en limitant strictement les informations collectées.',
        link: 'https://fr.matomo.org/',
        cookiesNames: [
            '_pk_ref',
            '_pk_cvar',
            '_pk_id',
            '_pk_ses',
            'mtm_consent',
            'mtm_consent_removed',
            'mtm_cookie_consent',
            'matomo_sessid',
            '_pk_hsr',
        ],
    }, {
        id: 'MATOMO_WITH_CONSENT',
        title: 'Matomo',
        group: 'ANALYTICS',
        description: 'Matomo en mode standard permet à Yurplan de recueillir des informations permettant de mieux comprendre comment la plateforme Yurplan est utilisée. Il permet de distinguer chaque utilisateur par l\'attribution d\'un identifiant unique.',
        link: 'https://fr.matomo.org/',
        cookiesNames: [
            '_pk_ref',
            '_pk_cvar',
            '_pk_id',
            '_pk_ses',
            'mtm_consent',
            'mtm_consent_removed',
            'mtm_cookie_consent',
            'matomo_sessid',
            '_pk_hsr',
        ],
    }, {
        id: 'HOTJAR',
        title: 'HotJar',
        group: 'ANALYTICS',
        description: 'Ce cookie tiers déposé par HotJar nous permet de visionner le parcours utilisateur sur le site. Il enregistre ainsi, entre autres, les pages visionnées, ainsi que les liens cliqués. La récolte de ces informations participe à l\'amélioration de notre plateforme.',
        link: 'https://www.hotjar.com/legal/policies/cookie-information',
        cookiesNames: [
            '_hjClosedSurveyInvites',
            '_hjDonePolls',
            '_hjMinimizedPolls',
            '_hjShownFeedbackMessage',
            '_hjSessionTooLarge',
            '_hjid',
            '_hjRecordingLastActivity',
            '_hjTLDTest',
            '_hjUserAttributesHash',
            '_hjCachedUserAttributes',
            '_hjLocalStorageTest',
            '_hjIncludedInPageviewSample',
            '_hjIncludedInSessionSample',
            '_hjAbsoluteSessionInProgress',
            '_hjFirstSeen',
            '_hjViewportId',
            '_hjRecordingEnabled',
        ],
        gtmKeys: ['hjtc'],
    }, {
        id: 'GOOGLE_OPTIMIZE',
        title: 'Google Optimize',
        group: 'ANALYTICS',
        description: 'Ce service tiers proposé par Google est utilisé afin de personnaliser et déterminer l\'efficacité de nos contenus.',
        link: 'https://policies.google.com/privacy?hl=fr&gl=fr',
        cookiesNames: [
            '_gaexp',
            '_opt_awcid',
            '_opt_awmid',
            '_opt_awgid',
            '_opt_awkid',
            '_opt_utmc',
            '_opt_expid',
        ],
        gtmKeys: ['opt'],
    }],
}, {
    id: 'MARKETING',
    name: 'Marketing',
    description: 'Ces cookies sont utilisés pour suivre votre navigation sur des sites webs à des fins de ciblage publicitaire. Le but est d\'afficher des publicités relatives à nos produits sur les sites de tiers utilisant ces cookies et de mesurer leur efficacité.',
    cookies: [{
        id: 'FACEBOOK_PIXEL',
        title: 'Facebook Pixel',
        group: 'MARKETING',
        description: 'Ces cookies tiers déposés par Facebook nous permettent de vous proposer, sur le site de Facebook, des publicités relatives à nos produits et d\'effectuer le suivi statistique desdites publicités.',
        link: 'https://www.facebook.com/policies/cookies/',
        cookiesNames: [
            'spin',
            'act',
            'fr',
            'locale',
            'presence',
            'pl',
            'xs',
            'wd',
            'c_user',
            'sb',
            'datr',
            '_fbp',
        ],
        gtmKeys: ['customScripts', 'customPixels'],
    }, {
        id: 'LINKEDIN',
        title: 'LinkedIn',
        group: 'MARKETING',
        description: 'Ces cookies tiers déposés par LinkedIn nous permettent de vous proposer, sur le site de LinkedIn, des publicités relatives à nos produits, et d\'effectuer le suivi statistique desdites publicités',
        link: 'https://www.linkedin.com/legal/cookie-policy',
        // https://fr.linkedin.com/legal/l/cookie-table?#thirdparty
        cookiesNames: [
            'li_at',
            'liap',
            'leadgen.api_session',
            'transaction_state',
            'PLAY_SESSION',
            'lihc_auth_str',
            'lihc_auth_*',
            'sessionid',
            'cp_session',
            'fid',
            'bcookie',
            'bscookie',
            'fcookie',
            'ccookie',
            'JSESSIONID',
            'chp_token',
            'li_cu',
            'cf_ob_info',
            'cf_use_ob',
            'cfuid',
            '__cfruid',
            '__cf_bm',
            'denial-client-ip',
            'denial-reason-code',
            'rtc',
            'trkInfo',
            'trkCode',
            'spectroscopyld',
            'fptctx2',
            'MUID',
            '__ssid',
            'li_referer',
            'f_token',
            'li_rm',
            'BizographicsOptOut',
            'ac_L',
            'ac_LD',
            'recent_history_status',
            'li_cc',
            'all_u_b',
            'lang',
            'uh',
            'pushPermInfo',
            'pushPermState',
            'G_AUTHUSER_H',
            'G_ENABLED_IDPS',
            'g_state',
            'lidc',
            'integration_type',
            'lissc',
            'lissc1',
            'lissc2',
            'interstitial_page_reg_oauth_url',
            'wwepo',
            'sdsc',
            'li_gc',
            'li_mc',
            'PLAY_FLASH',
            'PLAY_LANG',
            'visit',
            'redirectFromM2MInviteAccept',
            'redirectFromM2MInviteSent',
            'cookie.policy.banner.eu',
            'cookie.policy.banner.nl',
            'appName',
            'appLang',
            'lls-integration',
            'feed-sort',
            'first-time-user',
            'hc_lynda_consent',
            'abiRedirect',
            'sj_ubid',
            'UserMatchHistory',
            'AnalyticsSyncHistory',
            'li_oatml',
            'lms_ads',
            'lms_analytics',
            'li_fat_id',
            'li_sugr',
            'U',
            '_guid',
            'BizographicsOptOut',
            'UserMatchHistory',
            'li_oatml',
            'lms_ads',
            'li_fat_id',
            'li_sugr',
            'U',
            '_guid',
            'A3',
            'anj',
            'uuids',
            'ELOQUA',
            'ELQSTATUS',
            'dmp',
            'dextp',
            'demdex',
            'dst',
            'lnkd',
            'aam_uuid',
            'MUID',
            'MR',
            'MR2',
            'IDE',
            'fr',
            'personalization_id',
            'GUC',
            'B',
            'test_cookie',
            '_gcl_au',
            '_gcl_aw',
            '_gcl_dc',
            'brwsr',
            'ABSELB',
            'IRLD',
            '_gac_UA-62256447-1',
            'ASPSESSIONID',
            'SERVERID',
            'tuuid',
            'tuuid_lu',
            'c',
            'fl_inst',
            'pvc*',
            'pcc*',
            'trc',
            'ad2',
            'lms_analytics',
            'AnalyticsSyncHistory',
            'queryString',
            'SID',
            'VID',
            '_ga',
            '_gat',
            '_gid',
            'UID',
            'UIDR',
            's_cc',
            's_sq',
            's_vi',
            's_fid',
            'ki_r',
            'ki_s',
            'ki_t',
            'ki_u',
            'gpy_pn',
            's_plt',
            's_tslv',
            's_ppv',
            's_pltp',
            '_gac_UA-62256447-1',
            'recent_history',
            'liveagent_chatted',
            'liveagent_oref',
            'liveagent_ptid',
            'liveagent_sid',
            'liveagent_vc',
            'sharebox-suggestion',
            'at_check',
            'mbox',
            'hc_lynda_notification',
            'hc_survey',
        ],
        gtmKeys: ['bzi'],
    }, {
        id: 'GOOGLE_ADS',
        title: 'Google Ads',
        group: 'MARKETING',
        description: 'Ce cookie tiers déposé par Google est utilisé par Google Ads afin de déterminer l\'efficacité de la publicité sur divers sites Web utilisant leurs services.',
        link: 'https://policies.google.com/privacy?hl=fr&gl=fr',
        link2: 'https://support.google.com/adsense/answer/7549925?hl=fr',
        link3: 'https://policies.google.com/technologies/types?hl=fr',
        cookiesNames: [
            '_gcl_au',
        ],
        gtmKeys: ['awct', 'gclidw'],
    }],
},
];
